// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Pow from "../lib/Pow.js";
import * as React from "react";
import * as Preact from "../bindings/Preact.js";
import * as Ticket from "./Ticket.js";
import * as Storage from "../lib/Storage.js";
import * as Dispenser from "./Dispenser.js";
import * as GunHelpers from "../lib/GunHelpers.js";
import * as ServedScreen from "./ServedScreen.js";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function Queue$ConfirmDialog(props) {
  let onCancel = props.onCancel;
  let onConfirm = props.onConfirm;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("h3", {
          children: "Mark as Served?"
        }),
        JsxRuntime.jsx("p", {
          children: "This will remove you from the queue."
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("button", {
              children: "Cancel",
              className: "btn btn-outline",
              "data-testid": "cancel-btn",
              onClick: param => onCancel()
            }),
            JsxRuntime.jsx("button", {
              children: "Yes, I'm Done",
              className: "btn btn-primary",
              "data-testid": "confirm-btn",
              onClick: param => onConfirm()
            })
          ],
          className: "confirm-dialog-buttons"
        })
      ],
      className: "confirm-dialog"
    }),
    className: "confirm-dialog-overlay",
    "data-testid": "confirm-dialog"
  });
}

let ConfirmDialog = {
  make: Queue$ConfirmDialog
};

function Queue(props) {
  let storeId = props.storeId;
  let match = React.useState(() => {});
  let setStore = match[1];
  let store = match[0];
  let match$1 = React.useState(() => {});
  let setTicket = match$1[1];
  let ticket = match$1[0];
  let match$2 = React.useState(() => true);
  let setIsLoading = match$2[1];
  let match$3 = React.useState(() => {});
  let setError = match$3[1];
  let error = match$3[0];
  let match$4 = React.useState(() => false);
  let setIsTakingNumber = match$4[1];
  let isTakingNumber = match$4[0];
  let match$5 = React.useState(() => false);
  let setShowServedScreen = match$5[1];
  let match$6 = React.useState(() => false);
  let setShowConfirmDialog = match$6[1];
  let match$7 = React.useState(() => false);
  let setIsIncognito = match$7[1];
  let unsubscribeRef = React.useRef(undefined);
  let loadStore = async () => {
    try {
      let storeData = await GunHelpers.getStore(storeId, undefined);
      if (storeData !== undefined) {
        setStore(param => storeData);
      } else {
        setError(param => "Queue not found");
      }
    } catch (raw_err) {
      let err = Primitive_exceptions.internalToException(raw_err);
      if (err.RE_EXN_ID === "JsExn") {
        console.error(err._1);
        setError(param => "Failed to load queue");
      } else {
        throw err;
      }
    }
    return setIsLoading(param => false);
  };
  let checkExistingTicket = () => {
    if (!Storage.hasTicket(storeId)) {
      return;
    }
    let storedTicket = Storage.getTicket(storeId);
    if (storedTicket !== undefined) {
      if (storedTicket.status === "waiting") {
        return setTicket(param => storedTicket);
      } else if (storedTicket.status === "served") {
        return setShowServedScreen(param => true);
      } else {
        return;
      }
    }
  };
  React.useEffect(() => {
    if (Storage.isIncognito()) {
      setIsIncognito(param => true);
      setIsLoading(param => false);
    } else {
      GunHelpers.initGun(undefined);
      loadStore();
      checkExistingTicket();
    }
    return () => {
      let unsub = unsubscribeRef.current;
      if (unsub !== undefined) {
        return unsub();
      }
    };
  }, []);
  React.useEffect(() => {
    if (store === undefined) {
      return;
    }
    let unsub = GunHelpers.subscribeToStore(storeId, updatedStore => setStore(param => updatedStore));
    unsubscribeRef.current = unsub;
    return () => {
      unsub();
      unsubscribeRef.current = undefined;
    };
  }, [Stdlib_Option.isSome(store)]);
  let handleTakeNumber = async () => {
    if (isTakingNumber) {
      return;
    }
    setIsTakingNumber(param => true);
    setError(param => {});
    try {
      let keypair = await Pow.generateKeyPair();
      let deviceId = await Pow.getDeviceId(keypair);
      let existingTicket = await GunHelpers.getTicketByDeviceId(storeId, deviceId);
      let exit = 0;
      if (existingTicket !== undefined && existingTicket.status === "waiting") {
        setTicket(param => existingTicket);
        Storage.storeTicket(storeId, existingTicket);
      } else {
        exit = 1;
      }
      if (exit === 1) {
        let newTicket = await GunHelpers.createTicket(storeId, deviceId);
        setTicket(param => newTicket);
        Storage.storeTicket(storeId, newTicket);
      }
    } catch (raw_err) {
      let err = Primitive_exceptions.internalToException(raw_err);
      if (err.RE_EXN_ID === "JsExn") {
        let err$1 = err._1;
        console.error(err$1);
        let msg = Stdlib_Option.getOr(Stdlib_JsExn.message(err$1), "Failed to get ticket. Please try again.");
        setError(param => msg);
      } else {
        throw err;
      }
    }
    return setIsTakingNumber(param => false);
  };
  let handleMarkServed = () => {
    if (ticket !== undefined) {
      return setShowConfirmDialog(param => true);
    }
  };
  let handleConfirmServed = async () => {
    setShowConfirmDialog(param => false);
    if (ticket === undefined) {
      return;
    }
    try {
      await GunHelpers.markTicketServed(storeId, ticket.number, "Self");
      let updatedTicket_number = ticket.number;
      let updatedTicket_deviceId = ticket.deviceId;
      let updatedTicket_issuedAt = ticket.issuedAt;
      let updatedTicket_servedAt = ticket.servedAt;
      let updatedTicket_servedBy = ticket.servedBy;
      let updatedTicket = {
        number: updatedTicket_number,
        deviceId: updatedTicket_deviceId,
        issuedAt: updatedTicket_issuedAt,
        status: "served",
        servedAt: updatedTicket_servedAt,
        servedBy: updatedTicket_servedBy
      };
      setTicket(param => updatedTicket);
      Storage.storeTicket(storeId, updatedTicket);
      return setShowServedScreen(param => true);
    } catch (raw_err) {
      let err = Primitive_exceptions.internalToException(raw_err);
      if (err.RE_EXN_ID === "JsExn") {
        console.error(err._1);
        return setError(param => "Failed to mark as served. Please try again.");
      }
      throw err;
    }
  };
  let handleCancelServed = () => setShowConfirmDialog(param => false);
  let handleTakeAnother = () => {
    Storage.clearTicket(storeId);
    setTicket(param => {});
    setShowServedScreen(param => false);
  };
  let getPosition = () => {
    if (ticket === undefined) {
      return 0;
    }
    if (store === undefined) {
      return 0;
    }
    let nowServing = store.nowServing;
    let position = ticket.number - nowServing | 0;
    return Math.max(0, position);
  };
  let getExpiryTime = () => {
    if (ticket === undefined) {
      return;
    }
    let expiryTime = ticket.issuedAt + 24.0 * 60.0 * 60.0 * 1000.0;
    let now = Date.now();
    let remaining = expiryTime - now;
    if (remaining <= 0.0) {
      return "Expired";
    }
    let hours = remaining / (60.0 * 60.0 * 1000.0) | 0;
    let minutes = remaining % (60.0 * 60.0 * 1000.0) / (60.0 * 1000.0) | 0;
    return hours.toString() + `h ` + minutes.toString() + `m`;
  };
  if (match$7[0]) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("h1", {
            children: "🔒 Private Mode",
            className: "page-title"
          }),
          className: "page-header"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: "Please open this page in a regular browser window."
              }),
              JsxRuntime.jsx("p", {
                children: "Private/Incognito mode is not supported because we need to remember your ticket."
              })
            ],
            className: "incognito-warning",
            "data-testid": "incognito-warning"
          }),
          className: "container"
        })
      ],
      className: "page",
      "data-testid": "queue-page"
    });
  }
  if (match$2[0]) {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx("div", {
        children: "Loading...",
        className: "loading"
      }),
      className: "page",
      "data-testid": "queue-page"
    });
  }
  let exit = 0;
  if (error !== undefined) {
    if (store === undefined) {
      return JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("h1", {
              children: "Queue Not Found",
              className: "page-title"
            }),
            className: "page-header"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                  children: error
                }),
                JsxRuntime.jsx("p", {
                  children: "Please check the QR code and try again."
                })
              ],
              className: "error",
              "data-testid": "queue-error"
            }),
            className: "container"
          })
        ],
        className: "page",
        "data-testid": "queue-page"
      });
    }
    exit = 1;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    if (store === undefined) {
      return JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: "Loading...",
          className: "loading"
        }),
        className: "page",
        "data-testid": "queue-page"
      });
    }
    if (match$5[0]) {
      return JsxRuntime.jsx(ServedScreen.make, {
        storeName: store.name,
        onTakeAnother: handleTakeAnother
      });
    }
    let exit$1 = 0;
    if (ticket !== undefined) {
      if (ticket.status === "waiting") {
        let position = getPosition();
        let expiryTime = getExpiryTime();
        return JsxRuntime.jsxs("div", {
          children: [
            match$6[0] ? JsxRuntime.jsx(Queue$ConfirmDialog, {
                onConfirm: () => {
                  handleConfirmServed();
                },
                onCancel: handleCancelServed
              }) : null,
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("h1", {
                children: store.name,
                className: "page-title",
                "data-testid": "store-name"
              }),
              className: "page-header"
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Ticket.make, {
                  number: ticket.number,
                  storeName: store.name,
                  isRevealing: true
                }),
                JsxRuntime.jsx("div", {
                  children: position === 0 ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                          children: "Your Number",
                          className: "status-label"
                        }),
                        JsxRuntime.jsx("span", {
                          children: `#` + ticket.number.toString(),
                          className: "status-value",
                          "data-testid": "now-serving"
                        })
                      ],
                      className: "status-item"
                    }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                      children: [
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                              children: store.nowServing > 0 ? "Recently Served" : "Queue Status",
                              className: "status-label"
                            }),
                            JsxRuntime.jsx("span", {
                              children: store.nowServing > 0 ? `#` + store.nowServing.toString() : "No one yet",
                              className: "status-value",
                              "data-testid": "now-serving"
                            })
                          ],
                          className: "status-item"
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("span", {
                              children: "Ahead of You",
                              className: "status-label"
                            }),
                            JsxRuntime.jsx("span", {
                              children: position.toString() + ` ` + (
                                position === 1 ? "person" : "people"
                              ),
                              className: "status-value",
                              "data-testid": "people-ahead"
                            })
                          ],
                          className: "status-item"
                        })
                      ]
                    }),
                  className: "queue-status mt-3",
                  "data-testid": "queue-status"
                }),
                position === 0 ? JsxRuntime.jsx("div", {
                    children: "It's your turn!",
                    className: "your-turn-alert",
                    "data-testid": "your-turn"
                  }) : null,
                JsxRuntime.jsx("button", {
                  children: "I've Been Served ✓",
                  className: "btn btn-primary btn-full mt-3",
                  "data-testid": "mark-served-btn",
                  onClick: param => handleMarkServed()
                }),
                expiryTime !== undefined ? JsxRuntime.jsx("div", {
                    children: `⏰ Expires in ` + expiryTime,
                    className: "expiry-info mt-2",
                    "data-testid": "expiry-info"
                  }) : null,
                error !== undefined ? JsxRuntime.jsx("div", {
                    children: error,
                    className: "error-message mt-2"
                  }) : null,
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("p", {
                    children: "📱 Add to Home Screen for notifications"
                  }),
                  className: "pwa-prompt mt-4",
                  "data-testid": "pwa-prompt"
                })
              ],
              className: "container"
            })
          ],
          className: "page",
          "data-testid": "queue-page"
        });
      }
      exit$1 = 2;
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      return JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("h1", {
              children: store.name,
              className: "page-title",
              "data-testid": "store-name"
            }),
            className: "page-header"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("span", {
                    children: "Next number:",
                    className: "preview-label"
                  }),
                  JsxRuntime.jsx("span", {
                    children: `#` + (store.currentNumber + 1 | 0).toString(),
                    className: "preview-number"
                  })
                ],
                className: "next-number-preview",
                "data-testid": "next-number-preview"
              }),
              JsxRuntime.jsx(Dispenser.make, {
                onPull: () => {
                  handleTakeNumber();
                },
                isDisabled: isTakingNumber
              }),
              isTakingNumber ? JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                      children: "🎫",
                      className: "ticket-spinner"
                    }),
                    JsxRuntime.jsx("p", {
                      children: "Getting your number..."
                    })
                  ],
                  className: "taking-number-animation",
                  "data-testid": "taking-number"
                }) : null,
              error !== undefined ? JsxRuntime.jsx("div", {
                  children: error,
                  className: "error-message mt-2",
                  "data-testid": "error-message"
                }) : null,
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: store.nowServing > 0 ? "Recently Served" : "Queue Status",
                      className: "status-label"
                    }),
                    JsxRuntime.jsx("span", {
                      children: store.nowServing > 0 ? `#` + store.nowServing.toString() : "No one yet",
                      className: "status-value",
                      "data-testid": "now-serving"
                    })
                  ],
                  className: "status"
                }),
                className: "current-status mt-4"
              })
            ],
            className: "container"
          })
        ],
        className: "page",
        "data-testid": "queue-page"
      });
    }
  }
}

function expose() {
  Preact.setWindowProperty("Queue", Queue);
}

let make = Queue;

export {
  ConfirmDialog,
  make,
  expose,
}
/* react Not a pure module */
